// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file dev/moment/differential/v1alpha2/store.proto (package dev.moment.differential.v1alpha2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Struct } from "@bufbuild/protobuf";

/**
 * @generated from message dev.moment.differential.v1alpha2.TableSchema
 */
export class TableSchema extends Message<TableSchema> {
  /**
   * @generated from field: string primary_key = 1;
   */
  primaryKey = "";

  constructor(data?: PartialMessage<TableSchema>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.TableSchema";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "primary_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TableSchema {
    return new TableSchema().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TableSchema {
    return new TableSchema().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TableSchema {
    return new TableSchema().fromJsonString(jsonString, options);
  }

  static equals(a: TableSchema | PlainMessage<TableSchema> | undefined, b: TableSchema | PlainMessage<TableSchema> | undefined): boolean {
    return proto3.util.equals(TableSchema, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.InsertOp
 */
export class InsertOp extends Message<InsertOp> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  /**
   * @generated from field: google.protobuf.Struct value = 2;
   */
  value?: Struct;

  constructor(data?: PartialMessage<InsertOp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.InsertOp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "message", T: Struct },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InsertOp {
    return new InsertOp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InsertOp {
    return new InsertOp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InsertOp {
    return new InsertOp().fromJsonString(jsonString, options);
  }

  static equals(a: InsertOp | PlainMessage<InsertOp> | undefined, b: InsertOp | PlainMessage<InsertOp> | undefined): boolean {
    return proto3.util.equals(InsertOp, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.DeleteOp
 */
export class DeleteOp extends Message<DeleteOp> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  /**
   * @generated from field: google.protobuf.Struct value = 2;
   */
  value?: Struct;

  constructor(data?: PartialMessage<DeleteOp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.DeleteOp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "message", T: Struct },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteOp {
    return new DeleteOp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteOp {
    return new DeleteOp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteOp {
    return new DeleteOp().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteOp | PlainMessage<DeleteOp> | undefined, b: DeleteOp | PlainMessage<DeleteOp> | undefined): boolean {
    return proto3.util.equals(DeleteOp, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.ReplaceOp
 */
export class ReplaceOp extends Message<ReplaceOp> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  /**
   * @generated from field: google.protobuf.Struct value = 2;
   */
  value?: Struct;

  constructor(data?: PartialMessage<ReplaceOp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.ReplaceOp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "message", T: Struct },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReplaceOp {
    return new ReplaceOp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReplaceOp {
    return new ReplaceOp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReplaceOp {
    return new ReplaceOp().fromJsonString(jsonString, options);
  }

  static equals(a: ReplaceOp | PlainMessage<ReplaceOp> | undefined, b: ReplaceOp | PlainMessage<ReplaceOp> | undefined): boolean {
    return proto3.util.equals(ReplaceOp, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.UpsertOp
 */
export class UpsertOp extends Message<UpsertOp> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  /**
   * @generated from field: google.protobuf.Struct value = 2;
   */
  value?: Struct;

  constructor(data?: PartialMessage<UpsertOp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.UpsertOp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "message", T: Struct },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpsertOp {
    return new UpsertOp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpsertOp {
    return new UpsertOp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpsertOp {
    return new UpsertOp().fromJsonString(jsonString, options);
  }

  static equals(a: UpsertOp | PlainMessage<UpsertOp> | undefined, b: UpsertOp | PlainMessage<UpsertOp> | undefined): boolean {
    return proto3.util.equals(UpsertOp, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.CreateTableOp
 */
export class CreateTableOp extends Message<CreateTableOp> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  /**
   * @generated from field: string primary_key = 2;
   */
  primaryKey = "";

  constructor(data?: PartialMessage<CreateTableOp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.CreateTableOp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "primary_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTableOp {
    return new CreateTableOp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTableOp {
    return new CreateTableOp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTableOp {
    return new CreateTableOp().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTableOp | PlainMessage<CreateTableOp> | undefined, b: CreateTableOp | PlainMessage<CreateTableOp> | undefined): boolean {
    return proto3.util.equals(CreateTableOp, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.DropTableOp
 */
export class DropTableOp extends Message<DropTableOp> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  constructor(data?: PartialMessage<DropTableOp>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.DropTableOp";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DropTableOp {
    return new DropTableOp().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DropTableOp {
    return new DropTableOp().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DropTableOp {
    return new DropTableOp().fromJsonString(jsonString, options);
  }

  static equals(a: DropTableOp | PlainMessage<DropTableOp> | undefined, b: DropTableOp | PlainMessage<DropTableOp> | undefined): boolean {
    return proto3.util.equals(DropTableOp, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.Operation
 */
export class Operation extends Message<Operation> {
  /**
   * @generated from oneof dev.moment.differential.v1alpha2.Operation.op
   */
  op: {
    /**
     * @generated from field: dev.moment.differential.v1alpha2.InsertOp insert = 1;
     */
    value: InsertOp;
    case: "insert";
  } | {
    /**
     * @generated from field: dev.moment.differential.v1alpha2.DeleteOp delete = 2;
     */
    value: DeleteOp;
    case: "delete";
  } | {
    /**
     * @generated from field: dev.moment.differential.v1alpha2.ReplaceOp replace = 3;
     */
    value: ReplaceOp;
    case: "replace";
  } | {
    /**
     * @generated from field: dev.moment.differential.v1alpha2.UpsertOp upsert = 4;
     */
    value: UpsertOp;
    case: "upsert";
  } | {
    /**
     * @generated from field: dev.moment.differential.v1alpha2.CreateTableOp create_table = 5;
     */
    value: CreateTableOp;
    case: "createTable";
  } | {
    /**
     * @generated from field: dev.moment.differential.v1alpha2.DropTableOp drop_table = 6;
     */
    value: DropTableOp;
    case: "dropTable";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Operation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.Operation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "insert", kind: "message", T: InsertOp, oneof: "op" },
    { no: 2, name: "delete", kind: "message", T: DeleteOp, oneof: "op" },
    { no: 3, name: "replace", kind: "message", T: ReplaceOp, oneof: "op" },
    { no: 4, name: "upsert", kind: "message", T: UpsertOp, oneof: "op" },
    { no: 5, name: "create_table", kind: "message", T: CreateTableOp, oneof: "op" },
    { no: 6, name: "drop_table", kind: "message", T: DropTableOp, oneof: "op" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Operation {
    return new Operation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Operation {
    return new Operation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Operation {
    return new Operation().fromJsonString(jsonString, options);
  }

  static equals(a: Operation | PlainMessage<Operation> | undefined, b: Operation | PlainMessage<Operation> | undefined): boolean {
    return proto3.util.equals(Operation, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.ChangeEntry
 */
export class ChangeEntry extends Message<ChangeEntry> {
  /**
   * @generated from field: uint64 version = 1;
   */
  version = protoInt64.zero;

  /**
   * @generated from field: dev.moment.differential.v1alpha2.Operation operation = 2;
   */
  operation?: Operation;

  constructor(data?: PartialMessage<ChangeEntry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.ChangeEntry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "operation", kind: "message", T: Operation },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangeEntry {
    return new ChangeEntry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangeEntry {
    return new ChangeEntry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangeEntry {
    return new ChangeEntry().fromJsonString(jsonString, options);
  }

  static equals(a: ChangeEntry | PlainMessage<ChangeEntry> | undefined, b: ChangeEntry | PlainMessage<ChangeEntry> | undefined): boolean {
    return proto3.util.equals(ChangeEntry, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.StoreV2
 */
export class StoreV2 extends Message<StoreV2> {
  /**
   * @generated from field: uint64 version = 1;
   */
  version = protoInt64.zero;

  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha2.TableSchema> tables = 2;
   */
  tables: { [key: string]: TableSchema } = {};

  constructor(data?: PartialMessage<StoreV2>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.StoreV2";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "tables", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TableSchema} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StoreV2 {
    return new StoreV2().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StoreV2 {
    return new StoreV2().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StoreV2 {
    return new StoreV2().fromJsonString(jsonString, options);
  }

  static equals(a: StoreV2 | PlainMessage<StoreV2> | undefined, b: StoreV2 | PlainMessage<StoreV2> | undefined): boolean {
    return proto3.util.equals(StoreV2, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.TableRows
 */
export class TableRows extends Message<TableRows> {
  /**
   * @generated from field: repeated google.protobuf.Struct rows = 1;
   */
  rows: Struct[] = [];

  constructor(data?: PartialMessage<TableRows>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.TableRows";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rows", kind: "message", T: Struct, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TableRows {
    return new TableRows().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TableRows {
    return new TableRows().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TableRows {
    return new TableRows().fromJsonString(jsonString, options);
  }

  static equals(a: TableRows | PlainMessage<TableRows> | undefined, b: TableRows | PlainMessage<TableRows> | undefined): boolean {
    return proto3.util.equals(TableRows, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.CreateTableRequest
 */
export class CreateTableRequest extends Message<CreateTableRequest> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  /**
   * @generated from field: string primary_key = 2;
   */
  primaryKey = "";

  constructor(data?: PartialMessage<CreateTableRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.CreateTableRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "primary_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTableRequest {
    return new CreateTableRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTableRequest {
    return new CreateTableRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTableRequest {
    return new CreateTableRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTableRequest | PlainMessage<CreateTableRequest> | undefined, b: CreateTableRequest | PlainMessage<CreateTableRequest> | undefined): boolean {
    return proto3.util.equals(CreateTableRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.CreateTableResponse
 */
export class CreateTableResponse extends Message<CreateTableResponse> {
  constructor(data?: PartialMessage<CreateTableResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.CreateTableResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateTableResponse {
    return new CreateTableResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateTableResponse {
    return new CreateTableResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateTableResponse {
    return new CreateTableResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateTableResponse | PlainMessage<CreateTableResponse> | undefined, b: CreateTableResponse | PlainMessage<CreateTableResponse> | undefined): boolean {
    return proto3.util.equals(CreateTableResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.DropTableRequest
 */
export class DropTableRequest extends Message<DropTableRequest> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  constructor(data?: PartialMessage<DropTableRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.DropTableRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DropTableRequest {
    return new DropTableRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DropTableRequest {
    return new DropTableRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DropTableRequest {
    return new DropTableRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DropTableRequest | PlainMessage<DropTableRequest> | undefined, b: DropTableRequest | PlainMessage<DropTableRequest> | undefined): boolean {
    return proto3.util.equals(DropTableRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.DropTableResponse
 */
export class DropTableResponse extends Message<DropTableResponse> {
  constructor(data?: PartialMessage<DropTableResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.DropTableResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DropTableResponse {
    return new DropTableResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DropTableResponse {
    return new DropTableResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DropTableResponse {
    return new DropTableResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DropTableResponse | PlainMessage<DropTableResponse> | undefined, b: DropTableResponse | PlainMessage<DropTableResponse> | undefined): boolean {
    return proto3.util.equals(DropTableResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.EnsureCreatedRequest
 */
export class EnsureCreatedRequest extends Message<EnsureCreatedRequest> {
  constructor(data?: PartialMessage<EnsureCreatedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.EnsureCreatedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnsureCreatedRequest {
    return new EnsureCreatedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnsureCreatedRequest {
    return new EnsureCreatedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnsureCreatedRequest {
    return new EnsureCreatedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EnsureCreatedRequest | PlainMessage<EnsureCreatedRequest> | undefined, b: EnsureCreatedRequest | PlainMessage<EnsureCreatedRequest> | undefined): boolean {
    return proto3.util.equals(EnsureCreatedRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.EnsureCreatedResponse
 */
export class EnsureCreatedResponse extends Message<EnsureCreatedResponse> {
  /**
   * @generated from field: uint64 version = 1;
   */
  version = protoInt64.zero;

  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha2.TableSchema> tables = 2;
   */
  tables: { [key: string]: TableSchema } = {};

  constructor(data?: PartialMessage<EnsureCreatedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.EnsureCreatedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "tables", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TableSchema} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnsureCreatedResponse {
    return new EnsureCreatedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnsureCreatedResponse {
    return new EnsureCreatedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnsureCreatedResponse {
    return new EnsureCreatedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EnsureCreatedResponse | PlainMessage<EnsureCreatedResponse> | undefined, b: EnsureCreatedResponse | PlainMessage<EnsureCreatedResponse> | undefined): boolean {
    return proto3.util.equals(EnsureCreatedResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.MutateRequest
 */
export class MutateRequest extends Message<MutateRequest> {
  /**
   * @generated from field: uint64 last_seen_version = 1;
   */
  lastSeenVersion = protoInt64.zero;

  /**
   * @generated from field: repeated dev.moment.differential.v1alpha2.Operation operations = 2;
   */
  operations: Operation[] = [];

  constructor(data?: PartialMessage<MutateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.MutateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "last_seen_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "operations", kind: "message", T: Operation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MutateRequest {
    return new MutateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MutateRequest {
    return new MutateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MutateRequest {
    return new MutateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: MutateRequest | PlainMessage<MutateRequest> | undefined, b: MutateRequest | PlainMessage<MutateRequest> | undefined): boolean {
    return proto3.util.equals(MutateRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.MutateResponse
 */
export class MutateResponse extends Message<MutateResponse> {
  /**
   * @generated from field: uint64 version = 1;
   */
  version = protoInt64.zero;

  /**
   * @generated from field: repeated dev.moment.differential.v1alpha2.ChangeEntry changes = 2;
   */
  changes: ChangeEntry[] = [];

  constructor(data?: PartialMessage<MutateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.MutateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "changes", kind: "message", T: ChangeEntry, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): MutateResponse {
    return new MutateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): MutateResponse {
    return new MutateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): MutateResponse {
    return new MutateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: MutateResponse | PlainMessage<MutateResponse> | undefined, b: MutateResponse | PlainMessage<MutateResponse> | undefined): boolean {
    return proto3.util.equals(MutateResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.SnapshotRequest
 */
export class SnapshotRequest extends Message<SnapshotRequest> {
  constructor(data?: PartialMessage<SnapshotRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.SnapshotRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SnapshotRequest {
    return new SnapshotRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SnapshotRequest {
    return new SnapshotRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SnapshotRequest {
    return new SnapshotRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SnapshotRequest | PlainMessage<SnapshotRequest> | undefined, b: SnapshotRequest | PlainMessage<SnapshotRequest> | undefined): boolean {
    return proto3.util.equals(SnapshotRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.SnapshotResponse
 */
export class SnapshotResponse extends Message<SnapshotResponse> {
  /**
   * @generated from field: uint64 version = 1;
   */
  version = protoInt64.zero;

  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha2.TableRows> tables = 2;
   */
  tables: { [key: string]: TableRows } = {};

  constructor(data?: PartialMessage<SnapshotResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.SnapshotResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "tables", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TableRows} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SnapshotResponse {
    return new SnapshotResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SnapshotResponse {
    return new SnapshotResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SnapshotResponse {
    return new SnapshotResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SnapshotResponse | PlainMessage<SnapshotResponse> | undefined, b: SnapshotResponse | PlainMessage<SnapshotResponse> | undefined): boolean {
    return proto3.util.equals(SnapshotResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.ChangesRequest
 */
export class ChangesRequest extends Message<ChangesRequest> {
  /**
   * @generated from field: uint64 since_version = 1;
   */
  sinceVersion = protoInt64.zero;

  constructor(data?: PartialMessage<ChangesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.ChangesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "since_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangesRequest {
    return new ChangesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangesRequest {
    return new ChangesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangesRequest {
    return new ChangesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ChangesRequest | PlainMessage<ChangesRequest> | undefined, b: ChangesRequest | PlainMessage<ChangesRequest> | undefined): boolean {
    return proto3.util.equals(ChangesRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.differential.v1alpha2.ChangesResponse
 */
export class ChangesResponse extends Message<ChangesResponse> {
  /**
   * @generated from field: uint64 version = 1;
   */
  version = protoInt64.zero;

  /**
   * @generated from field: repeated dev.moment.differential.v1alpha2.ChangeEntry changes = 2;
   */
  changes: ChangeEntry[] = [];

  constructor(data?: PartialMessage<ChangesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.differential.v1alpha2.ChangesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "changes", kind: "message", T: ChangeEntry, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ChangesResponse {
    return new ChangesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ChangesResponse {
    return new ChangesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ChangesResponse {
    return new ChangesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ChangesResponse | PlainMessage<ChangesResponse> | undefined, b: ChangesResponse | PlainMessage<ChangesResponse> | undefined): boolean {
    return proto3.util.equals(ChangesResponse, a, b);
  }
}

